<!-- 横向步骤条 -->
<template>
  <div>
    <div class="step-container">
      <el-steps :active="isActive" align-center>
        <el-step
          v-for="item in stepList"
          :title="item.title"
          :key="item.id"
          :description="item.description ? item.description : ''"
        ></el-step>
      </el-steps>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    stepList: {
      type: Array,
      default: () => []
    },
    isActive: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {};
  },

  components: {},

  computed: {},

  created() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.step-container {
  margin: 20px 52px 0px 52px;
}

.step-container ::v-deep .el-step__head.is-success .el-step__icon.is-text {
  width: 30px;
  height: 30px;
  background: #2587ff;
  border: 0;
}
.step-container ::v-deep .el-step__title.is-success {
  color: #2587ff;
}
.step-container ::v-deep .el-step__title.is-success.el-step__icon-inner {
  color: #2587ff;
}
.step-container ::v-deep .el-step__head.is-process .el-step__icon.is-text {
  width: 30px;
  height: 30px;
  background: #2587ff;
  border: 0;
  color: #fff;
}
.step-container ::v-deep .el-step__head.is-wait .el-step__icon.is-text {
  width: 30px;
  height: 30px;
  background: #d9d9d9;
  border: 1px solid #d9d9d9;
  color: #fff;
}
.step-container ::v-deep .el-step__title.is-success {
  color: #2587ff;
}
::v-deep .el-step__head.is-success {
  color: #fff;
  border-color: #2587ff;
}
.step-container ::v-deep .el-step.is-horizontal .el-step__line {
  height: 1px;
}
.step-container ::v-deep .el-step__description.is-success {
  color: #666666;
}
.step-container ::v-deep .el-step__title.is-process {
  color: #2587ff;
  font-size: 14px;
  font-weight: normal;
}
.step-container ::v-deep .el-step__description.is-process {
  color: #2587ff;
}
.el-step ::v-deep .el-step__title {
  font-size: 14px;
}
// .el-step__head ::v-deep.el-step__icon{
//   width: 30px;
//   height: 30px;
// }
::v-deep .Active {
  .el-step__head {
    .el-step__icon {
      width: 30px;
      height: 30px;
    }
  }
}
.step-container ::v-deep .el-step__head.is-finish {
  color: #fff;
}
.step-container ::v-deep .el-step__description.is-finish {
  color: #666;
}

.step-container ::v-deep .el-step__icon.is-text {
  background: #2587ff;
  width: 30px;
  height: 30px;
}

::v-deep .stepActive {
  .el-step__head.is-finish {
    .el-step__icon.is-text {
      background: #2587ff;
      color: #fff;
    }
  }
}
::v-deep .step01,
.step02,
.step03,
.step04,
.step05 {
  width: 14px;
  height: 10px;
  background-size: 100% 100%;
}
</style>
